import { createWebHistory, createRouter } from 'vue-router'
import { useGlobalStore } from '@stores/global'

/* Layouts */
import App from '@layouts/App.vue'

/* Pages */
import Index from '@pages/Index.vue'
import Host from '@pages/Host.vue'
import Event from '@pages/Event.vue'
import Events from '@pages/Events.vue'
import Tournament from '@pages/Tournament.vue'
import Galleries from '@pages/Galleries.vue'
import Media from '@pages/Media.vue'
import News from '@pages/News.vue'
import Article from '@pages/Article.vue'
import PointsRanking from '@pages/PointsRanking.vue'
import Player from '@pages/Player.vue'

/* Routes */
const routes = [
	{
		path: '/',
		component: App,
		children: [
			{ path: '', name: 'index', component: Index },
			// { path: 'host', name: 'host', component: Host },
			{ path: 'tournament/:slug', name: 'tournament', component: Tournament },
			// { path: 'event/:slug', name: 'event', component: Event },
			{ path: 'events', name: 'events', component: Events },
			{ path: 'points-ranking', name: 'points-ranking', component: PointsRanking },
			{ path: 'player/:slug?', name: 'player', component: Player },
			{ path: 'media-gallery', name: 'galleries', component: Galleries },
			{ path: 'media/:slug?', name: 'media', component: Media },
			{ path: 'news', name: 'news', component: News },
			{ path: 'article/:slug?', name: 'article', component: Article },
			{
				path: '/leaderboard',
				name: 'leaderboard',
				redirect: { name: 'points-ranking' },
			},
			{
				path: '/leaderboards',
				name: 'leaderboards',
				redirect: { name: 'points-ranking' },
			},
			{
				path: '/:catchAll(.*)',
				name: '404',
				redirect: { name: 'index' },
			},
		],
	},
]

/* Hashes are also used as tab identifiers, so they don't always match an element. */
const hashElementExists = (hash) => {
	try {
		return Boolean(hash && document.querySelector(hash))
	} catch {
		return false
	}
}

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			if (hashElementExists(to.hash)) {
				return {
					el: to.hash,
					top: 100,
					behavior: 'smooth',
				}
			}
			// A tab hash shouldn't move the page the tabs are on.
			return to.name == from.name ? false : { top: 0 }
		} else if (to.name == from.name) {
			return { top: 0, behavior: 'smooth' }
		} else {
			return {
				top: 0,
			}
		}
	},
	history: createWebHistory(),
	routes,
})

router.beforeEach((to, from, next) => {
	const global = useGlobalStore()
	global.closeModal()
	next()
})

const isModifiedClick = (event) => event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey

/* Anything falling through to the catch-all is served outside the SPA (/admin, /storage, ...). */
const isServerRoute = (location) => location.matched.some((record) => record.name === '404')

/* Routes plain anchors (e.g. in v-html markdown) through the router. */
document.addEventListener('click', (event) => {
	if (isModifiedClick(event)) return

	const anchor = event.target?.closest?.('a[href]')
	if (!anchor) return
	if (anchor.target && anchor.target !== '_self') return
	if (anchor.hasAttribute('download')) return
	if (anchor.getAttribute('rel')?.split(/\s+/).includes('external')) return

	let url
	try {
		url = new URL(anchor.getAttribute('href'), window.location.href)
	} catch {
		return
	}

	if (url.protocol !== 'http:' && url.protocol !== 'https:') return
	// Host rather than origin, so content authored with a hardcoded scheme still routes internally.
	if (url.host !== window.location.host) return

	const target = `${url.pathname}${url.search}${url.hash}`
	if (target === router.currentRoute.value.fullPath) return
	if (isServerRoute(router.resolve(target))) return

	event.preventDefault()
	router.push(target)
})

export default router
